import Vue from 'vue'

import VueTreeNode from '@/VueTreeNode.vue'
import props from '@/props'

export default Vue.extend({
  name: 'VueTree',
  components: {
    VueTreeNode
  },
  props
})



// WEBPACK FOOTER //
// ./src/VueTree.ts